import * as React from 'react'

const GoBackIcon = (props: { className?: string }) => {
  return (
    <svg
      className={'icon ' + props.className}
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M8 16L0 8L8 0' transform='translate(2 1)' stroke='#333333' strokeWidth='2' />
      <path
        d='M0.552402 2.28571H14.2976'
        transform='translate(3.14258 6.71387)'
        stroke='#333333'
        strokeWidth='2'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default GoBackIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/GoBack.tsx